import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
export function HeroSection() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);
  return <section style={{
    backgroundColor: 'var(--color-cream)'
  }} className="relative overflow-hidden min-h-screen flex items-center" data-id="element-19">
      {/* Decorative background shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-20 pointer-events-none" style={{
      background: 'radial-gradient(circle, var(--color-terracotta-light), transparent 70%)',
      transform: 'translate(30%, -30%)'
    }} data-id="element-20" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full opacity-15 pointer-events-none" style={{
      background: 'radial-gradient(circle, var(--color-burgundy), transparent 70%)',
      transform: 'translate(-30%, 30%)'
    }} data-id="element-21" />
      <div className="absolute top-1/2 left-1/4 w-64 h-64 rounded-full opacity-10 pointer-events-none" style={{
      background: 'radial-gradient(circle, var(--color-gold), transparent 70%)',
      transform: 'translate(-50%, -50%)'
    }} data-id="element-22" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 py-20 text-center" data-id="element-23">
        {/* ── PRODUCT PRESENTATION (first thing seen) ── */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '0ms'
      }} data-id="element-24">
          <p className="font-sans text-sm font-semibold uppercase tracking-widest mb-4" style={{
          color: 'var(--color-terracotta)'
        }} data-id="element-25">
            Presentamos:
          </p>
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl font-black mb-2" style={{
          color: 'var(--color-text-dark)'
        }} data-id="element-26">
            MAMÁ SIN CULPA
          </h1>
          <p className="font-serif text-2xl italic mb-8" style={{
          color: 'var(--color-gold)'
        }} data-id="element-27">
            El Método 5-15
          </p>
        </div>

        {/* Product image */}
        <div className={`transition-all duration-700 mb-8 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '150ms'
      }} data-id="element-28">
          <img src="https://cdn.magicpatterns.com/uploads/sid1J6Q9eY8XVdot9sgsga/mama_sin_culpa_imagen_1.png" alt="Mamá Sin Culpa — El Método 5-15 en tablet y móvil" className="w-full max-w-lg mx-auto rounded-2xl" style={{
          boxShadow: '0 24px 64px rgba(44, 24, 16, 0.18)'
        }} data-id="element-29" />
        </div>

        {/* Description */}
        <div className={`transition-all duration-700 mb-10 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '300ms'
      }} data-id="element-30">
          <p className="font-sans text-lg sm:text-xl leading-relaxed max-w-2xl mx-auto" style={{
          color: 'var(--color-text-mid)'
        }} data-id="element-31">
            Este no es un libro de 300 páginas que no tienes tiempo de leer. Es
            un{' '}
            <strong style={{
            color: 'var(--color-text-dark)'
          }} data-id="element-32">
              mapa de rescate emocional
            </strong>{' '}
            diseñado para la mujer que vive en el caos real.
          </p>
        </div>

        {/* Eyebrow tagline */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '400ms'
      }} data-id="element-33">
          <span className="inline-block text-xs font-sans font-semibold uppercase tracking-widest mb-6 px-4 py-2 rounded-full" style={{
          color: 'var(--color-terracotta)',
          backgroundColor: 'rgba(196, 98, 45, 0.1)',
          border: '1px solid rgba(196, 98, 45, 0.2)'
        }} data-id="element-34">
            Para la mamá hispana en USA que está agotada pero no lo dice
          </span>
        </div>

        {/* Main Headline */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '500ms'
      }} data-id="element-35">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-4" style={{
          color: 'var(--color-text-dark)'
        }} data-id="element-36">
            Criar en USA sin tu familia cerca es el trabajo más difícil del
            mundo.
          </h2>
        </div>

        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '600ms'
      }} data-id="element-37">
          <p className="font-serif text-2xl sm:text-3xl italic font-normal mb-8" style={{
          color: 'var(--color-burgundy)'
        }} data-id="element-38">
            Deja de intentar hacerlo sola y perfecta.
          </p>
        </div>

        {/* Price Badge */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '700ms'
      }} data-id="element-39">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-40">
            <span className="font-sans text-sm font-medium line-through opacity-50" style={{
            color: 'var(--color-text-mid)'
          }} data-id="element-41">
              $19.99
            </span>
            <span className="font-serif text-2xl font-bold px-5 py-2 rounded-full" style={{
            backgroundColor: 'var(--color-terracotta)',
            color: '#fff'
          }} data-id="element-42">
              Solo $6.39
            </span>
            <span className="font-sans text-xs font-semibold px-3 py-1 rounded-full" style={{
            backgroundColor: 'rgba(212, 168, 83, 0.2)',
            color: 'var(--color-gold)',
            border: '1px solid var(--color-gold)'
          }} data-id="element-43">
              OFERTA LIMITADA
            </span>
          </div>
        </div>

        {/* Trust Badges */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
        transitionDelay: '800ms'
      }} data-id="element-44">
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6" data-id="element-45">
            {['Descarga inmediata', '100% en español', 'Diseñado para tu realidad'].map(item => <div key={item} className="flex items-center gap-2" data-id="element-46">
                <CheckCircle size={16} style={{
              color: 'var(--color-terracotta)'
            }} data-id="element-47" />
                <span className="font-sans text-sm font-medium" style={{
              color: 'var(--color-text-mid)'
            }} data-id="element-48">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Decorative divider */}
        <div className="mt-16 flex items-center justify-center gap-4 opacity-30" data-id="element-49">
          <div className="h-px w-16" style={{
          backgroundColor: 'var(--color-terracotta)'
        }} data-id="element-50" />
          <span style={{
          color: 'var(--color-terracotta)'
        }} data-id="element-51">
            ✦
          </span>
          <div className="h-px w-16" style={{
          backgroundColor: 'var(--color-terracotta)'
        }} data-id="element-52" />
        </div>
      </div>
    </section>;
}